import axios, { AxiosError, AxiosResponse } from "axios";
import { ActionCreator, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { IMapState } from "../Models/Models";
import * as types from "./Types";

declare let scout;

const setLoadingLastSession = (loadingLastSession: boolean) => ({
    type: types.SET_LOADING_LAST_SESSION,
    data: loadingLastSession,
});

const setFoundLastSession = (foundLastSession: boolean) => ({
    type: types.SET_FOUND_LAST_SESSION,
    data: foundLastSession,
});

const setLastSession = (session: IMapState) => ({
    type: types.SET_SESSION,
    data: session,
});

export const getLastSession: ActionCreator<ThunkAction<any, any, any, any>>
    = () => {
        return (dispatch: Dispatch<any>) => {
            dispatch(setLoadingLastSession(true));

            axios
                .get("/MapState/GetLatestMapState")
                .then((response: AxiosResponse) => {
                    const session: IMapState = response.data.data;

                    //Replace autosave ID cookie if it doesn't match the id just retrieved.
                    //This should get everyone set with a new ID the first time they log in after this release
                    const currentAutoSaveID: string = scout.logic.LocalSettingsLogic?.get(
                        "autosaveid",
                        null
                    );

                    const shouldSetAutoSaveId
                        = session?.shareId?.toUpperCase() !== null
                        && currentAutoSaveID?.toUpperCase() !== null
                        && currentAutoSaveID?.toUpperCase() !== session?.shareId?.toUpperCase();

                    if (shouldSetAutoSaveId) {
                        scout.logic.LocalSettingsLogic.set(
                            "autosaveid",
                            session.shareId.toUpperCase()
                        );
                    }

                    dispatch(setLastSession(session));

                    if (!session) {
                        dispatch(setFoundLastSession(false));
                    } else {
                        dispatch(setFoundLastSession(true));
                    }

                    dispatch(setLoadingLastSession(false));
                })
                .catch((error: AxiosError) => {
                    console.error(error);
                    dispatch(setLastSession(null));
                    dispatch(setLoadingLastSession(false));
                    dispatch(setFoundLastSession(false));
                });
        };
    };
